import { GridOption } from "../enums";

export interface IGridOption {
  operation: GridOption
}
